export default {
    filtro: {
        periodo_padrao: 'Período estándar',
        periodo_personalizado: 'Período personalizado',
        mais_filtros: 'Más filtros',
        vns: 'VNS',
        recipiente: 'Envase/ID',
        empresa: 'Empresa',
        paciente: 'Paciente',
        tipo_integracao: 'Tipo de Integración',
        status: 'Estado',
        status_filtro: {
            todos: 'Todo',
            novo: 'Nuevo',
            ativo: 'Online',
            desconectado: 'Desconectado',
            analise: 'Bajo Análisis',
            offline: 'Offline'
        },
        erros: {
            label: 'Errores',
            dexpara: 'Todos los errores de de x a',
            exame: 'Errores de x a examen',
            metodo: 'Errores de x a método',
            material: 'Errores de x a material'
        },
        filtrar_button: 'Filtrar',
        limpar_button: 'Filtros Claros'
    },
    automacao: {
        titulo: 'Pedidos y Resultados',
        ordens: 'Pedidos',
        resultados: 'Resultados'
    },
    link: {
        titulo: 'Pedidos y Resultados - Apoyo',
        ordens: 'Pedidos',
        resultados: 'Resultados',
        numero_pedido: 'Numéro del Pedido'
    },
    lis: {
        titulo: 'Pedidos y Resultados - Lis'
    },
    periodos: {
        trinta_minutos: 'Hace 30 minutos',
        uma_hora: '1 hora antes',
        hoje: 'Hoy',
        sete_dias: 'Los últimos 7 días',
        mes_atual: 'Mes actual',
        mes_anterior: 'Mes pasado',
        ano_atual: 'Año corriente',
        ano_anterior: 'El año pasado'
    },
    messages:{
        resend: {
            success: '¡Reenvío Exitoso!',
            error: '¡Error al volver a enviar!',
            recipient_diference: '¡Para reenviar el resultado, el número de contenedor debe ser diferente al original!',
            reason_required: '¡Indique el motivo del cambio de contenedor!'
        },
        reprint: {
            success: '¡Impresión terminada!',
            error: '¡Error al imprimir la etiqueta!'
        },
        file_not_found: '¡Archivo no encontrado!',
        file_error: '¡Error al leer el archivo!',
        getObservation: {
            success: '¡Los resultados se solicitarán al laboratorio de soporte!',
            error: '¡Error al obtener resultados!'
        }
    },
    table: {
        fields: {
            recipiente: 'Envase/ID',
            informacoes: 'Información',
            vns: 'VNS',
            empresa: 'Empresa',
            paciente: 'Paciente',
            ultima_atualizacao: 'Última actualización',
            acoes: 'Acciónes'
        },
        status: {
            ordem_recebida: 'Orden Recibida',
            no_equipamento: 'Procesado en EQPT',
            resultados: 'Resultado Enviado',
            completos: 'Resultados completos',
            erro_dexpara: 'Error en De X A',
            erro_suporte: 'Error de Soporte / Origen'
        }
    },
    modal: {
        titulo: 'Examenes',
        reenviar_ordem: 'Reenviar Pedido',
        reenviar_resultado: 'Reenviar Resultado',
        reemprimir_etiqueta: 'Etiqueta de Reimpresión',
        dados: 'Datos',
        arquivo: 'Archivo',
        lis_bruto: 'LIS bruto',
        lis_formatado: 'LIS formateado',
        vns_bruto: 'VNS bruto',
        vns_formatado: 'VNS formateado',
        table: {
            recipiente: 'Envase/ID',
            paciente: 'Paciente',
            athlete: 'Atleta/ID',
            horario: 'Tiempo',
            exame_lis: 'Examen LIS',
            exame_vns: 'Examen de Integración',
            status: 'Estado',
            acoes: 'Acciónes',
            erro: 'Error'
        },
        details: {
            ordem_exam_code_lis: 'Orden LIS',
            ordem_exam_code_vns: 'Orden de Integración',
            resultado_exam_code_lis: 'Resultado LIS',
            resultado_exam_code_vns: 'Resultado de Integración',
            metodo_origem: 'Método de origen',
            metodo_destino: 'Método de destino',
            valor: 'Valor',
            unidade: 'Unidad',
            texto_referencia: 'Texto de referencia',
            estrutura_referencia: 'Estructura de referencia',
            tipo_resultado: 'Tipo de Resultado',
            tipo_resultado_decimal: 'Decimal',
            tipo_resultado_alfanumerico: 'Alfanumérico',
            processado: 'Procesado en',
            status_protocolo: 'Estado del Protocolo',
            motivo_revisao: 'Motivo de la Revisión de Resultado',
            usuario_revisao: 'Usuario que revisó el resultado',
            protocolo_status: {
                available: 'Disponible',
                blocked: 'Bloqueado',
                review: 'En Revisión',
                reviewed: 'Revisado',
                sent: 'Enviado',
                canceled: 'Cancelado'
            },
            mapping: {
                exam_originCode: 'Examen LIS',
                exam_destinationCode: 'Examen de Integración',
                specimen_originCode: 'Material LIS',
                specimen_destinationCode: 'Material de Integración',
                method_originCode: 'Método LIS',
                method_destinationCode: 'Método de Integración',
                parent_exam_originCode: 'Examen padre LIS',
                parent_exam_destinationCode: 'Examen padre de Integración'
            },
            exame_lis: 'Examen Origen',
            exame: 'Examen',
            origem: 'Origen',
            destino: 'Destino',
            material_lis: 'Material Origen',
            material: 'Material',
            numero_pedido: 'Número de Pedido',
            metodo: 'Método',
            material_adicional: 'Material Adicional',
            complemento_material_lis: 'Complemento Origen',
            complemento_material: 'Complemento Destino',
            especie: 'Especie',
            raca: 'Raza',
            pelagem: 'Abrigo',
            porte: 'Tamaño',
            exames: 'Exámenes',
            complementos_exames: 'Complementos de Examen',
            controle_qualidade: 'Control de Calidad',
            pet: 'Pet',
            erros_suporte: 'Errores de Soporte',
            erros_origem: 'Errores de Origen',
            mensagem: 'Mensaje',
            data_hora: 'Fecha y Hora',
            protocolo: 'Protocolo',
            editar_recipiente: 'Editar Contenedor',
            recipiente_alterado: 'Contenedor Alterado',
            recipientes_reenviados: 'Recipientes Reenviados',
            novo_recipiente: 'Nuevo Recipiente',
            vs_usuario_id: 'ID de Usuario VS',
            vs_usuario_name: 'Nombre de Usuario VS',
            criado_em: 'Creado En',
            motivo: 'Motivo',
            resend: {
                change_recipient: "Cambie el número del recipiente y reenvíe el resultado del examen:",
                fix_recipient_number: "Corrija el número del recipiente:",
                fix_recipient_number_placeholder: "ingrese el nuevo número del recipiente",
                edit_reason: "Motivo de la Modificación:",
                edit_reason_placeholder: "Indique el motivo ...",
                resend_result: "Reenviar Resultado"
            },
            changed: {
                original_recipient: "Recipiente Original:",
                user_id: "ID del Usuario:",
                user_name: "Nombre del Usuario:",
                reason: "Motivo:"
            }
        },
        getObservation :{
            pending: 'Buscar resultados pendientes',
            all: 'Obtener y reenviar todos los resultados'
        },
        file_detail: {
            empty: '¡Ningún archivo encontrado!',
            reenviar_arquivo: 'Reenviar archivo',
            arquivo: 'Archivo',
            etapa: 'Etapa',
            reenviar: 'Reenviar'
        },
        recipiente: {
            exames: 'Exámenes',
            horario: 'Horario',
            arquivos: 'Archivos',
            status: 'Estado',
            acoes: 'Acciones',
            resultado: 'Resultado',
            ordem: 'Orden',
            carregando_ordens: 'Cargando Órdenes',
            carregando_resultados: 'Cargando Resultados'
        },
        report_result_detail: {
            resultado: 'Resultado',
            inconclusivo: 'Inconclusivo',
            reagente: 'Reactivo',
            nao_reagente: 'No reactivo',
            enviar_resultados: 'Enviar Resultado(s)',
            informe_resultado_exame: 'Informe el resultado para el Examen:',
            exame: 'Examen:',
            sem_de_para: 'no tiene un De X Para para la integración de destino en este momento de orden',
            resultado_recebido: '¡Resultado recibido exitosamente!',
            erro_transmitir_resultado: 'Error al transmitir el resultado, verifica la consola.'
        }
                
    }
}
